import { useEffect, useState } from "react";
import Navbar from "@/components/Navbar";
import SiteFooter from "@/components/public/SiteFooter";
import PageHero from "@/components/public/PageHero";
import api from "@/lib/api";

export default function Terms() {
  const [terms, setTerms] = useState({ title: "Terms & Conditions", body: "" });
  useEffect(() => { api.get("/public/terms").then((r) => setTerms(r.data)).catch(() => {}); }, []);
  return (
    <div className="public-site min-h-screen bg-slate-50">
      <Navbar dark />
      <PageHero overline="Legal" title={terms.title} />
      <div className="mx-auto max-w-4xl px-5 py-12 lg:py-16" data-testid="terms-page">
        <div className="rounded-3xl border border-slate-200 bg-white p-8 leading-relaxed text-slate-700 sm:p-12">
          <div className="whitespace-pre-wrap">{terms.body || "Our terms and conditions will be published here soon."}</div>
        </div>
      </div>
      <SiteFooter />
    </div>
  );
}
